import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AImagePlaceholder } from '../atoms';

export default function MProductPlacement({ onClick }) {
	const handleKeyDown = (event) => {
		if (event.keyCode === 13) {
			onClick();
		}
	}
	return (
		<section
			role="button"
			tabIndex="0"
			onClick={onClick}
			onKeyDown={handleKeyDown}
			className="m-product-placement"
		>
			<AImagePlaceholder />
			<p>
				<FormattedMessage id="PRODUCT_COMPARE.CHOOSE_SECOND_PRODUCT" defaultMessage="" />
			</p>
		</section>
	);
}

MProductPlacement.propTypes = {
	onClick: PropTypes.func,
};

MProductPlacement.defaultProps = {
	onClick: undefined,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.product-placement.js